import { createBrowserRouter } from "react-router-dom";
import HomepageUser from "../Components/Users/Homepage";
import Dashboard from "../Components/Users/dashboard";

import { AdminNavbar, AdminLogin, ForgetPageLink, ForgetPassword } from "../Components/admin/index";

//users
import {
  BidderRegister,
  ShowAuctions,
  Reciept,
  RecieptForm,
  ContactUs,
  AboutUs,
  RegistrationForm
} from "../Components/Users/pages";
//admin
import {
  TenderWinnerRefund,
  EditRoles,
  CustomMisReport,
  MISActiveReport,
  CreateDepartment,
  EditViewEmp,
  CreateEmployee,
  CreateRoles,
  WinnerDeclartionForm,
  AuctionWinnerDeclartion,
  CreateAuction,
  AuctionRefund,
  AdminDashboard,
  ShowAuctionsAdmin,
  GenerateRefund,
  PaymentTable,
  RefundFiles,
  AdminPassKeys,
  OpenTenders,
  ClosedTenders,
  Authorization,
  RefundCheck,
  TenderCancelRefund,
  GenerateTenderCancelRefund,
  CustomerReciept,
  Report
  , UploadPage, ViewFilePage, DataTable 
} from "../Components/admin/pages/index";


let token = localStorage.getItem("Usertoken");

const router = createBrowserRouter([
  {
    path: "/AdminLogin",
    element: <AdminLogin />,
  },
  {
    path: "/ForgetPassword",
    element: <ForgetPassword />,
  },
  {
    path: "/ForgetPageLink/:Link",
    element: <ForgetPageLink />
  },
  {
    path: "/AdminDashboard",
    element: <AdminNavbar />,
    children: [
      {
        path: "",
        element: <AdminDashboard />,
      },
      {
        path: "RefundCheck",
        element: <RefundCheck />,
      },
      {
        path: "Authorization",
        element: < Authorization />,
      },

      {
        path: "EditRoles",
        element: <EditRoles />,
      },
      {
        path: "CustomMisReport",
        element: <CustomMisReport />,
      },
      {
        path: "MISActiveReport",
        element: <MISActiveReport />,
      },
      {
        path: "CreateDepartment",
        element: <CreateDepartment />,
      },
      {
        path: "CreateEmployee",
        element: <CreateEmployee />,
      },
      {
        path: "EditViewEmp",
        element: <EditViewEmp />,
      },
      {
        path: "CreateRoles",
        element: <CreateRoles />,
      },
      {
        path: "EditAuction",
        element: <ShowAuctionsAdmin />,
      },
      {
        path: "CreateAuction",
        element: <CreateAuction />,
      },
      {
        path: "TenderWinnerRefund",
        element: <TenderWinnerRefund />,
      },
      {
        path: "AuctionRefund",
        element: <AuctionRefund />,
      },
      {
        path: "TenderCancelRefund",
        element: <TenderCancelRefund />
      },
      {
        path: "GenerateTenderCancelRefund/:id/:AuctionName",
        element: <GenerateTenderCancelRefund />
      },
      {
        path: "AuctionWinnerDeclartion/",
        element: <AuctionWinnerDeclartion />,
      },
      {
        path: "WinnerDeclartionForm/:id",
        element: <WinnerDeclartionForm />,
      },
      {
        path: "GenerateRefund/:id/:AuctionName",
        element: <GenerateRefund />,
      },
      {
        path: "PaymentTable",
        element: <PaymentTable />,
      },
      {
        path: "RefundFiles",
        element: <RefundFiles />,
      },
      {
        path: "AdminPassKeys",
        element: <AdminPassKeys />
      },
      {
        path: "OpenTenders",
        element: <OpenTenders />
      },
      {
        path: "ClosedTenders",
        element: <ClosedTenders />
      },
      {
        path:"CustomerReciept",
        element:<CustomerReciept/>
      },
      {
        path:"Report",
        element:<Report/>
      },
      {
        path: "UploadPage",
        element: <UploadPage />
      },
      {
        path: "ViewFilePage/:filename",
        element: <ViewFilePage />
      },
      {
        path: "DataTable",
        element: <DataTable />
      }
    ],
  },
  {
    path: "/",
    element: <HomepageUser />,
    errorElement: <div>Sorry</div>,
  },
  {
    path: "/Dashboard",
    element: <Dashboard />,
    errorElement: <div>Sorry</div>,
    children: [
      {
        path: "BidderRegister/:Auction_ID/:Auction_Name",
        element: <BidderRegister />,
      },
      {
        path: "ShowAuctions",
        element: <ShowAuctions />,
      },
      {
        path: "Reciept",
        element: <RecieptForm />,
      },
      {
        path: "RegistrationForm",
        element: <RegistrationForm />
      },
      {
        path: "DownloadReciept/:tid/:gst/:panno",
        element: <Reciept />,
      },
      {
        path: "contactUs",
        element: <ContactUs />
      },
      {
        path: "AboutUs",
        element: <AboutUs />
      }
    ],
  },
]);

export default router;
